<template>
  <v-row>
    <v-col cols="12" sm="6" md="4" lg="3">
      <v-card class="elevation-10">
        <v-card-title>
          <v-spacer/>
          Акты приходов
          <v-spacer/>
        </v-card-title>
        <v-card-text>
          <div class="text-center">
            <v-icon size="64" color="primary">assignment</v-icon>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text :to="{name: 'korzinka-acts-in'}">Открыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col cols="12" sm="6" md="4" lg="3">
      <v-card class="elevation-10">
        <v-card-title>
          <v-spacer/>
          Акты возвратов
          <v-spacer/>
        </v-card-title>
        <v-card-text>
          <div class="text-center">
            <v-icon size="64" color="primary">assignment</v-icon>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text :to="{name: 'korzinka-acts-out'}">Открыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "KorzinkaDashboard"
}
</script>